export enum EDocumentFilterOnly {
  OPEN_COMMENTS_ONLY = 'open_comments_only',
  BOOKMARK_ONLY = 'bookmark_only',
}

export interface RequestFilters {
  filter_by?: { [key: string]: unknown[] } | null
  filter_only?: EDocumentFilterOnly | null
  limit?: number | null
  offset?: number | null
  q?: string | null
  sort_by?: string | null
}

/**
 * Pagination metadata for list responses
 */
export interface PaginationInfo {
  /** Whether there are more pages */
  has_next: boolean
  /** Whether there are previous pages */
  has_previous: boolean
  /** Current page number */
  page: number
  /** Items per page */
  page_size: number
  /** Total number of items */
  total_items: number
  /** Total number of pages */
  total_pages: number
}

export interface ResponseMetadata {
  /** API version */
  api_version?: string
  /** Audit trail identifier */
  audit_trail_id?: string | null
  /** Compliance assurance level */
  compliance_level?: string
  /** Request correlation ID for tracing */
  correlation_id: string
  /** Request processing time */
  processing_time_ms?: number | null
  /** Remaining requests in current window */
  rate_limit_remaining?: number | null
  /** Seconds until rate limit resets */
  rate_limit_reset?: number | null
  /** Unique request identifier */
  request_id: string
  /** Service version */
  service_version?: string
  /** Response timestamp (ISO format) */
  timestamp?: string
}

export interface SuccessResponseListBool {
  data: boolean[]
  links?: { [key: string]: string } | null
  metadata: ResponseMetadata
  pagination?: PaginationInfo | null
  success?: boolean
  warnings?: string[] | null
}

/**
 * Error details for API error responses
 */
export interface ApiErrorDetail {
  code: string
  message: string
  type: string
  details: unknown
  cause: unknown
}

/**
 * Metadata for error responses
 */
export interface ErrorResponseMetadata {
  api_version?: string
  audit_trail_id?: string | null
  compliance_level?: string
  correlation_id: string
  processing_time_ms?: number | null
  rate_limit_remaining?: number | null
  rate_limit_reset?: number | null
  request_id: string
  service_version?: string
  timestamp?: string
}

/**
 * Base error structure for all domain exceptions
 */
export interface BaseError {
  /** Underlying cause (debug mode only) */
  cause?: string | null
  /** ErrorCode.value */
  code: string
  /** Additional error details (debug mode only) */
  details?: { [key: string]: unknown } | null
  /** Human-defined error message */
  message: string
  /** Error class type like ValidationError, AuthenticationError, etc. */
  type: string
}

/**
 * Standard error response envelope
 */
export interface ErrorResponse {
  /** Typed error details */
  error: BaseError
  /** Incident tracking identifier */
  incident_id?: string | null
  /** Response metadata */
  metadata: ResponseMetadata
  /** Always false for error responses */
  success?: boolean
}

export interface SuccessResponseList<T> {
  data: T[]
  /** HATEOAS links */
  links?: { [key: string]: string } | null
  /** Response metadata */
  metadata?: ResponseMetadata
  /** Pagination info for list responses */
  pagination?: PaginationInfo | null
  /** Always true for success responses */
  success?: boolean
  /** Non-blocking warnings */
  warnings?: string[] | null
}

/**
 * API Error type for catch blocks
 * Represents errors thrown by API requests
 */
export interface ApiError {
  response?: {
    data?: {
      message?: string
      error?: BaseError
    }
    status?: number
    statusText?: string
  }
  message?: string
}
